import { ShopSoort } from "./shop.soort";
import { AppLogEntry } from "./app.log.entry";

export class HeartbeatInfo {
  Timestamp: Date;
  CurrentShop: ShopSoort;
  CurrentLocation: string;
  LogEntries: AppLogEntry[];
}
